var _desc, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroDesktopFavouriteYellowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 480,
    viewBox: "0 0 640 480",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.6")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04 0 0 0.92 313 238.55)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_151",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 24 0)",
    x1: 0,
    y1: 255.95307636162244,
    x2: 527.8748862888472,
    y2: 255.95307636162244
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgba(0, 0, 0, 1)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgba(255, 170, 0, 1)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 50,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_151)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-287.94, -255.95)",
    d: "M 287.9 0 C 297.1 0 305.5 5.25 309.5 13.52 L 378.1 154.8 L 531.4 177.5 C 540.4 178.8 547.8 185.1 550.7 193.7 C 553.5 202.4 551.2 211.9 544.8 218.2 L 433.6 328.4 L 459.9 483.9 C 461.4 492.9 457.7 502.1 450.2 507.4 C 442.8 512.7 432.1 513.4 424.9 509.1 L 287.9 435.9 L 150.1 509.1 C 142.9 513.4 133.1 512.7 125.6 507.4 C 118.2 502.1 114.5 492.9 115.1 483.9 L 142.2 328.4 L 31.11 218.2 C 24.65 211.9 22.36 202.4 25.2 193.7 C 28.03 185.1 35.5 178.8 44.49 177.5 L 197.7 154.8 L 266.3 13.52 C 270.4 5.249 278.7 0 287.9 0 L 287.9 0 z M 287.9 78.95 L 235.4 187.2 C 231.9 194.3 225.1 199.3 217.3 200.5 L 98.98 217.9 L 184.9 303 C 190.4 308.5 192.9 316.4 191.6 324.1 L 171.4 443.7 L 276.6 387.5 C 283.7 383.7 292.2 383.7 299.2 387.5 L 404.4 443.7 L 384.2 324.1 C 382.9 316.4 385.5 308.5 391 303 L 476.9 217.9 L 358.6 200.5 C 350.7 199.3 343.9 194.3 340.5 187.2 L 287.9 78.95 z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroDesktopFavouriteYellowIcon);
export default __webpack_public_path__ + "static/media/Asset-KuroDesktopFavouriteYellowIcon.d3f071f957feeb62654b199780780070.svg";
export { ForwardRef as ReactComponent };